// extracted by mini-css-extract-plugin
module.exports = {"image":"moolax-module--image--1RsFr","background":"moolax-module--background--3v1e6"};